module.exports = __webpack_public_path__ + "img/banner_rog_xbox.0e8aa461.jpg";